function validatePhone(phoneNumber, validNumberOfDigits) {
    return phoneNumber.replace(/[&/\\#,+()$~%.'":*?<>{}_-]/g, '').length === validNumberOfDigits;
}

export default {
    validatePhone
};
